import React from 'react';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import { ApiHelpers } from '../../helpers';
import { Spin } from 'antd';

const withAuthentication = Component => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                authUser: undefined, // undefined = loading, null = not authenticated, object = authenticated
                userProfile: null,
                loading: true,
                error: null,
                initialAuthCheck: false // Flag to track if initial auth check is complete
            };
        }

        componentDidMount() {
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                async authUser => {
                    if (authUser) {
                        // User is signed in, fetch their profile from your API
                        try {
                            const userResponse = await ApiHelpers.getUser(authUser.uid);

                            // Create enhanced user object with both Firebase and API data
                            const enhancedUser = {
                                // Firebase auth data
                                uid: authUser.uid,
                                email: authUser.email,
                                emailVerified: authUser.emailVerified,
                                displayName: authUser.displayName,
                                photoURL: authUser.photoURL,

                                // Your API user profile data
                                profile: userResponse.data,

                                // Helper methods
                                getIdToken: () => authUser.getIdToken(),
                                reload: () => authUser.reload()
                            };

                            this.setState({
                                authUser: enhancedUser,
                                userProfile: userResponse.data,
                                loading: false,
                                error: null,
                                initialAuthCheck: true
                            });

                        } catch (error) {
                            console.error('Failed to fetch user profile:', error);

                            // Still set Firebase user but with error state
                            const basicUser = {
                                uid: authUser.uid,
                                email: authUser.email,
                                emailVerified: authUser.emailVerified,
                                displayName: authUser.displayName,
                                photoURL: authUser.photoURL,
                                profile: null,
                                getIdToken: () => authUser.getIdToken(),
                                reload: () => authUser.reload()
                            };

                            this.setState({
                                authUser: basicUser,
                                userProfile: null,
                                loading: false,
                                error: error.message || 'Failed to load user profile',
                                initialAuthCheck: true
                            });
                        }
                    } else {
                        // User is signed out
                        console.log('User signed out or not authenticated');
                        this.setState({
                            authUser: null, // null means definitely not authenticated
                            userProfile: null,
                            loading: false,
                            error: null,
                            initialAuthCheck: true
                        });
                    }
                },
                (error) => {
                    console.error('Firebase auth state change error:', error);
                    this.setState({
                        authUser: null,
                        userProfile: null,
                        loading: false,
                        error: error.message,
                        initialAuthCheck: true
                    });
                }
            );
        }

        componentWillUnmount() {
            this.listener();
        }

        render() {
            // Show loading screen while initial authentication is checking
            if (!this.state.initialAuthCheck) {
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        flexDirection: 'column'
                    }}>
                        <Spin size="large" />
                        <div style={{ marginTop: '16px', fontSize: '16px', color: '#666' }}>
                            Loading...
                        </div>
                    </div>
                );
            }

            return (
                <AuthUserContext.Provider value={this.state.authUser}>
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            );
        }
    }

    return withFirebase(WithAuthentication);
};

export default withAuthentication;